export const MediaType = {
  IMAGE: 1,
  VIDEO: 2
}
